'use client';
import SvgRenderer from '@/components/shared/svg_renderer';
import { FooterLink, SocialLink } from '@/types/types';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { getRegionalUrl } from '@/lib/regionalUrl';
import React, { useState } from 'react';

const FooterLinks = ({
  data,
  social,
}: {
  data: FooterLink[];
  social: SocialLink[];
}) => {
  const params = useParams<{ countryCode?: string }>();
  const countryCode = params?.countryCode;
  const [openHeadings, setOpenHeadings] = useState<string[]>([]);

  const handleToggleDropdown = (heading: string) => {
    setOpenHeadings((prevOpenHeadings) =>
      prevOpenHeadings.includes(heading)
        ? prevOpenHeadings.filter((openHeading) => openHeading !== heading)
        : [...prevOpenHeadings, heading]
    );
  };

  return (
    <footer
      className={`w-full flex flex-col sm:flex-row gap-5 flex-wrap justify-between md:[html[data-country=in]_&]:justify-start md:[html[data-country=in]_&]:gap-x-10 lg:[html[data-country=in]_&]:gap-x-32 xl:pr-10 pb-4`}
    >
      {data?.map((item, index) => (
        <div
          key={index}
          className={`flex md:w-48 lg:w-auto w-full text-wrap flex-col pb-3 px-2 md:border-none border-b border-black border-opacity-30 gap-3 ${
            !openHeadings.includes(item?.title) ? 'md:flex-shrink-0' : ''
          }`}
        >
          <div
            onClick={() => handleToggleDropdown(item?.title)}
            className="flex w-full items-center justify-between"
          >
            <p
              className={`font-semibold text-[16px] font-proxima_font cursor-pointer md:cursor-default ${
                openHeadings.includes(item?.title) ? '' : ''
              }`}
            >
              {item?.title}
            </p>
            <span
              className={`chevron md:hidden ${openHeadings.includes(item?.title) ? 'up' : 'down'}`}
            />
          </div>

          <ul
            className={`flex flex-col gap-2 font-medium font-proxima_font ${
              openHeadings.includes(item?.title)
                ? 'overflow-visible max-h-screen transition-all duration-500 ease-in'
                : 'overflow-hidden max-h-0 transition-all duration-500 ease-in-out md:max-h-none'
            }`}
          >
            {item?.sub_menu_items?.map((link, linkIndex) => (
              <li
                className={`${
                  openHeadings.includes(item?.title)
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-8 md:translate-y-0 md:opacity-100'
                } transition-all duration-700`}
                key={linkIndex}
              >
                <Link
                  className=" text-black text-[16px] font-proxima_font hover:underline transition-all duration-300"
                  href={getRegionalUrl(link?.path, countryCode)}
                  prefetch={false}
                  aria-label="Footer links"
                >
                  {link?.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </footer>
  );
};

export default FooterLinks;
